import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Bundle, Truckload } from '@paragon/contract-library';

interface TruckloadsState {
  [truckloadGuid: string]: Truckload;
}

const initialState: TruckloadsState = {};

const truckloadsSlice = createSlice({
  name: 'truckloads',
  initialState,
  reducers: {
    truckloadsLoaded: (state, action: PayloadAction<readonly Truckload[]>) => {
      for (const truckload of action.payload) {
        state[truckload.guid] = castDraft(truckload);
      }
    },
    truckloadCreated: (state, action: PayloadAction<{ truckload: Truckload; bundleGuids: readonly string[] }>) => {
      const { truckload } = action.payload;
      state[truckload.guid] = castDraft(truckload);
    },
    truckloadDeleted: (state, action: PayloadAction<{ truckloadGuid: string; updatedBundles: readonly Bundle[] }>) => {
      delete state[action.payload.truckloadGuid];
    },
  },
});

export const { truckloadsLoaded, truckloadCreated, truckloadDeleted } = truckloadsSlice.actions;
export const truckloads = truckloadsSlice.reducer;
